import React, { Component } from "react";
import TagService from "../service/tagService";
import TaskService from '../service/taskService';
import TaskStatusService from '../service/taskStatusService';
import TaskListWithCheckbox from '../components/tasklistWithCheckbox';
import NavigationBar from "../components/navigationBar";

class TagDetailSite extends Component {

    constructor(props) {
        super(props);
        this.tagService = new TagService();
        this.taskService = new TaskService();
        this.taskStatusService = new TaskStatusService();
        this.state = {
            tag: null,
            taskStatuses: [],
            tasks: [],
            tagTasks: [],
            selectedAddTasks: [],
            selectedRemoveTasks: []
        }

        this.handleAddCheckBoxChange = this.handleAddCheckBoxChange.bind(this);
        this.handleRemoveCheckBoxChange = this.handleRemoveCheckBoxChange.bind(this);
        this.releaseTag = this.releaseTag.bind(this);
        this.removeTasksFromTag = this.removeTasksFromTag.bind(this)
        this.addTasksToTag = this.addTasksToTag.bind(this)
    }

    componentDidMount() {
        this.getTagInformation();
        this.getTaskStatuses();
        this.getOpenTasks();
        this.getTagTasks();
    }

    async getTagInformation() {
        let result = await this.tagService.getReleaseTag(this.props.match.params.tagUUID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tag: result
            })
        }
    }

    async addTasksToTag() {
        let result = await this.tagService.addTasksToReleaseTag(this.props.match.params.tagUUID, this.state.selectedAddTasks);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.getTagTasks();
        }
    }

    async removeTasksFromTag() {

        let result = await this.tagService.removeTasksFromReleaseTag(this.props.match.params.tagUUID, this.state.selectedRemoveTasks);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.getTagTasks();
        }
    }

    async getTaskStatuses() {
        let result = await this.taskStatusService.getTaskStatuses();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                taskStatuses: result
            })
        }
    }

    handleAddCheckBoxChange(event, taskUUID) {
        let existsIndex = this.state.selectedAddTasks.indexOf(taskUUID);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.selectedAddTasks;
                array.push(taskUUID);
                this.setState(() => ({ selectedAddTasks: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.selectedAddTasks;
                array.splice(existsIndex, 1);
                this.setState(() => ({ selectedAddTasks: array }))
            }
        }
    }

    handleRemoveCheckBoxChange(event, taskUUID) {
        let existsIndex = this.state.selectedRemoveTasks.indexOf(taskUUID);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.selectedRemoveTasks;
                array.push(taskUUID);
                this.setState(() => ({ selectedRemoveTasks: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.selectedRemoveTasks;
                array.splice(existsIndex, 1);
                this.setState(() => ({ selectedRemoveTasks: array }))
            }
        }
    }

    async releaseTag(event) {
        event.preventDefault();
        let result = await this.tagService.releaseTag(this.props.match.params.tagUUID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.getTagInformation();
        }
    }

    async getOpenTasks() {
        let result = await this.taskService.retrieveTasks(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tasks: result
            })
        }
    }

    async getTagTasks() {
        let result = await this.tagService.getTasksInTag(this.props.match.params.tagUUID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tagTasks: result
            })
        }
    }


    render() {
        const tag = this.state.tag;
        if (!tag) return null;
        const taskStatuses = this.state.taskStatuses;
        if (taskStatuses.length === 0) return null;

        //console.log(this.props.match.params.projectID);
        return (
            <div className="body">
                <NavigationBar {...this.props} />
                <main>

                    <p>{tag.releaseName}</p>
                    <p>{tag.releaseDescription}</p>
                    <p>{(tag.releasedTime !== null ? tag.releasedTime : "Not Released")}</p>

                    <button disabled={(tag.releasedTime !== null ? true : false)} onClick={(event) => (this.releaseTag(event))}>Release tag</button>

                    <TaskListWithCheckbox tasks={this.state.tagTasks} taskStatuses={this.state.taskStatuses} projectUUID={this.props.match.params.projectID} SelectedTasksCallBack={this.handleRemoveCheckBoxChange} />
                    <button onClick={(event) => (this.removeTasksFromTag(event))}>Remove tasks from tag</button>

                    <TaskListWithCheckbox tasks={this.state.tasks} taskStatuses={this.state.taskStatuses} projectUUID={this.props.match.params.projectID} SelectedTasksCallBack={this.handleAddCheckBoxChange} />
                    <button onClick={(event) => (this.addTasksToTag(event))}>Add tasks to tag</button>
                </main>


            </div>
        )
    }
}

export default TagDetailSite;


// WEBPACK FOOTER //
// ./src/sites/tagDetailSite.js